<template>
  <a-drawer width="55vw" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <div>
      <a-collapse v-model="activeKey">
        <a-collapse-panel key="1" header="结算单信息">
          <a-descriptions title="结算单">
            <a-descriptions-item label="结算单号"> {{ form.settlementNo }} </a-descriptions-item>
            <a-descriptions-item label="账单开始日期">
              {{ parseTime(form.startTime, '{y}-{m}-{d}') }}
            </a-descriptions-item>
            <a-descriptions-item label="账单结束日期">
              {{ parseTime(form.endTime, '{y}-{m}-{d}') }}</a-descriptions-item
            >
            <a-descriptions-item label="订单总金额"> {{ form.orderTotalMoney }} </a-descriptions-item>
            <a-descriptions-item label="店铺金额">
              {{ form.shopMoney }}
            </a-descriptions-item>
            <a-descriptions-item label="平台抽成">
              {{ form.platformMoney }}
            </a-descriptions-item>
            <a-descriptions-item label="返佣金额">
              {{ form.rebateMoney }}
            </a-descriptions-item>
          </a-descriptions>
        </a-collapse-panel>
        <a-collapse-panel key="2" header="结算订单列表" :disabled="false">
          <a-table
            :columns="columns"
            :row-key="(record) => record.id"
            :data-source="list"
            :pagination="pagination"
            :loading="loading"
            @change="handleTableChange"
          >
            <template slot="name" slot-scope="name"> {{ name.first }} {{ name.last }} </template>
          </a-table>
        </a-collapse-panel>
      </a-collapse>
    </div>
  </a-drawer>
</template>

<script>
import { getSettlementOrder, addSettlementOrder, updateSettlementOrder } from '@/api/settlement/settlementOrder'
import { mapGetters } from 'vuex'
import CustomDictTag from '@/components/DictCustomTag'
import { generateFilePath, uploadObject } from '@/api/tool/oss'
import { pageSell } from '@/api/order/sell'
export default {
  name: 'CreateForm',
  props: {},
  components: {
    CustomDictTag,
  },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      // 表单参数
      form: {
        id: null,

        startTime: null,

        endTime: null,

        orderTotalMoney: null,

        shopId: null,

        shopMoney: null,

        platformMoney: null,

        rebateMoney: null,

        settlementNo: null,

        createTime: null,

        remark: null,
      },
      columns: [
        {
          title: '订单编号',
          dataIndex: 'id',
          sorter: true,
        },
        {
          title: '店铺名称',
          dataIndex: 'shopName',
        },
        {
          title: '下单时间',
          dataIndex: 'createTime',
        },
        {
          title: '买家名称',
          dataIndex: 'buyerName',
          sorter: true,
        },
        {
          title: '商品数量',
          dataIndex: 'goodsCount',
        },
        {
          title: '订单原价',
          dataIndex: 'orderAmount',
        },
        {
          title: '实付金额',
          dataIndex: 'payAmount',
        },
        {
          title: '支付方式',
          dataIndex: 'payTypeName',
        },
      ],
      pagination: {},
      loading: false,
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {},
      queryParam: {
        settlementOrderId: null,
        pageNum: 1,
        pageSize: 10,
      },
    }
  },
  filters: {},
  created() {},
  computed: {
    ...mapGetters(['customDict']),
  },
  watch: {},
  mounted() {},
  methods: {
    onClose() {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    previewVideoCancel() {
      this.previewVideoVisible = false
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        startTime: null,
        endTime: null,
        orderTotalMoney: null,
        shopId: null,
        shopMoney: null,
        platformMoney: null,
        rebateMoney: null,
        settlementNo: null,
        createTime: null,
        remark: null,
      }
    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      this.queryParam.settlementOrderId = id
      getSettlementOrder({ id: id }).then((response) => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
      this.getList()
    },
    /** 查询销售订单列表 */
    getList() {
      this.loading = true
      pageSell(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          let message = ''
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('通用.文本.修改成功')
            updateSettlementOrder(this.form)
              .then((response) => {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
              })
          } else {
            message = this.$t('通用.文本.修改成功')
            addSettlementOrder(this.form)
              .then((response) => {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
              })
          }
        } else {
          return false
        }
      })
    },
  },
}
</script>
